var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHangmanTaskGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 58,
    viewBox: "0 0 48 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_168)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 49H26",
    stroke: "#5DEE7A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 50V2",
    stroke: "#5DEE7A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 1H36",
    stroke: "#5DEE7A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 1V12",
    stroke: "#5DEE7A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 22V36",
    stroke: "#5DEE7A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 29H44",
    stroke: "#5DEE7A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7854 34.766L26.6429 41.5997",
    stroke: "#5DEE7A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7102 34.296L42.1936 41.8458",
    stroke: "#5DEE7A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 23C38.3137 23 41 20.3137 41 17C41 13.6863 38.3137 11 35 11C31.6863 11 29 13.6863 29 17C29 20.3137 31.6863 23 35 23Z",
    fill: "#5DEE7A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_168",
    x: 0,
    y: 0,
    width: 48,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_168",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 50,
    fill: "white",
    transform: "translate(4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangmanTaskGreen);
export default __webpack_public_path__ + "static/media/hangman-task-green.c825fc979410aa10b0933be1032b20a2.svg";
export { ForwardRef as ReactComponent };